/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step1_TitleInputs */

const es_cap_step1_title = /** @type {(inputs: Cap_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu perfil`)
};

const gl_cap_step1_title = /** @type {(inputs: Cap_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea o teu perfil`)
};

const en_cap_step1_title = /** @type {(inputs: Cap_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your profile`)
};

/**
* | output |
* | --- |
* | "Create your profile" |
*
* @param {Cap_Step1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step1_title = /** @type {((inputs?: Cap_Step1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step1_title(inputs)
	if (locale === "en") return en_cap_step1_title(inputs)
	return es_cap_step1_title(inputs)
});